<template>
  <div id="app" class="container-fluid container-application clearfix">
    <router-view/>
    <span @click="showMenuFun()" class="daohangBox yuanjiao d-lg-none">
      <i class="iconfont icon-daohang"></i>
    </span>
    <!--侧边弹框-->
    <transition appear mode='out-in' enter-active-class='animated animated2 slideInRight' leave-active-class='animated animated2 slideOutRight'>
      <div v-if="isShowGlobalRightBox" class="rightBoxModel" @click.self="closeRightBoxFun">
        <component :closeRightBoxFun="closeRightBoxFun" :parameter="localCart" :obj="obj" :is="isCompnentElement"></component>
        <span class="guanbiBtn cursor huanchongKuai" @click="closeRightBoxFun(false)">
          <i class="iconfont icon-icon-arrow-right2"></i>
        </span>
      </div>
    </transition>
    <!--加载-->
    <div class="jiazaiBox" v-if="isLoading">
      <span class="yuanjiao" v-if="isLoadingShow">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </span>
    </div>
    <!--购物车-->
    <span v-if="localUser" class="gouwucheBtn" @click="showModel()">
      <i class="iconfont icon-gouwuchekong"></i>
      <span v-if="localCart">{{localCart.length}}</span>
      <span v-else>0</span>
    </span>
    <span class="gouwucheBtn goTopBtn" @click="byScrollTop()">
      <i class="iconfont icon-fanhuidingbu"></i>
    </span>
  </div>
</template>

<script>
import uiProductContent from '@/components/product/Content';
import uiWechat from '@/components/common/wechat';
import uiDaohang from '@/components/common/daohang';
import generalMix from '@/util/mix/general';
import { EventBus } from '@/util/eventBus';

export default {
  name: 'App',
  mixins: [generalMix],
  data() {
    return {
      // 全局右侧视图框
      obj: '',
      isShowGlobalRightBox: false,
      isCompnentElement: '',
      isLoading:false,
      isLoadingShow:false
    };
  },
  methods:{
    // 模态框
    closeRightBoxFun() {
      this.isShowGlobalRightBox = false;
      this.obj = '';
      this.isCompnentElement = '';
      $('html').removeClass('scrollHide');
    },
    // 导航
    showMenuFun() {
      this.isCompnentElement = 'ui-daohang';
      this.obj = {};
      this.isShowGlobalRightBox = true;
      $('html').addClass('scrollHide');
    },
    showModel() {
      this.isCompnentElement = 'ui-product-content';
      this.isShowGlobalRightBox = true;
      $('html').addClass('scrollHide');
    },
    byScrollTop() {
      document.documentElement.scrollTop = 0;
      window.pageYOffset = 0; // 兼容iOS
      document.body.scrollTop = 0; // 兼容低版本IE
    }
  },
  created() {
    // 创建全局弹框
    const that = this;
    EventBus.$on('globalRightBoxFun', (ob) => {
      // 案例
      if (ob.type === 1) {
        that.isCompnentElement = 'ui-anli';
        that.obj = ob.obj;
        that.isShowGlobalRightBox = true;
      }
      // 微信二维码
      if (ob.type === 2) {
        that.isCompnentElement = 'ui-wechat';
        that.obj = ob.obj;
        that.isShowGlobalRightBox = true;
      }
      if (ob.type === 3) {
        that.isCompnentElement = 'ui-fangan';
        that.obj = ob.show;
        that.isShowGlobalRightBox = true;
      }
      $('html').addClass('scrollHide');
    });
    EventBus.$on('globalLoadingFun', (ob) => {
      that.isLoading = ob.bool;
      that.isLoadingShow = ob.loading;
    });
  },
  components: {
    'ui-wechat': uiWechat,
    'ui-daohang': uiDaohang,
    'ui-product-content':uiProductContent
  }
}
</script>

<style scoped lang="less">
#app{
  position: relative;
  height: 100%;
  span.gouwucheBtn{
    position: fixed;
    top: 120px;
    right: 50px;
    width: 60px;
    height: 60px;
    background: #FFFFFF;
    border-radius: 50%;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    color: #000000;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column-reverse;
    cursor: pointer;
    i{
      font-size: 22px;
      margin-top: -3px;
    }
    span{
      font-weight: bold;
      font-size: 18px;
    }
    &:hover{
      color: #2A37FE;
    }
    &.goTopBtn{
      display: none;
    }
  }
  @media (max-width: 992px) {
    span.gouwucheBtn{
      position: fixed;
      top: auto;
      right: 20px;
      width: 50px;
      height: 50px;
      bottom: 80px;
      i{
        font-size: 18px;
        margin-top: -3px;
      }
      span{
        font-weight: bold;
        font-size: 14px;
      }
      &.goTopBtn{
        display: flex;
        bottom: 20px;
        i{
          margin-top: 0;
        }
      }
    }
  }
  .daohangBox{
    position: fixed;
    top: 30px;
    right: 20px;
    background: #FFFFFF;
    display: block;
    width: 45px;
    height: 45px;
    box-shadow: 0 0 1rem rgba(0, 0, 0, .1);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    i{
      font-size: 20px;
      color: #000000;
    }
  }
  .jiazaiBox{
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    span{
      background: #FFFFFF;
      width: 65px;
      height: 65px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 15px;
      box-shadow: 0 0 1rem rgba(0,0,0,.2);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue